/*
Bar Pulls
  --length <float> | inches
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Bar'
const id = 'MWpovAbsKUHE79wGznPr'

export default {
  name,
  id,
  filters,
  headers,
  form
}
